import { useTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import { Property, PropertyBusinessType } from 'models/Properties';
import { PropertiesTableContainer } from './PropertiesTable.styles';

interface PropertiesTableProps {
  properties: Property[];
}

const PropertiesTable = ({ properties }: PropertiesTableProps) => {
  const { t } = useTranslation();

  const formatPropertyName = (property: Property) => {
    if (property.businessType === PropertyBusinessType.HOTEL) {
      return t(
        'pageScreenAndProtect.detailsPage.propertiesSelectModal.list.hotel',
        { name: property.name },
      );
    }

    if (
      property.businessType === PropertyBusinessType.STANDALONE_PROPERTY &&
      property.numberOfSubUnits > 0
    ) {
      return t(
        'pageScreenAndProtect.detailsPage.propertiesSelectModal.list.master',
        { name: property.name },
      );
    }

    return property.name;
  };

  return (
    <PropertiesTableContainer>
      {/* using react-bootstrap table instead of CommonTable with useTable because it's simpler and to avoid re-rendering issues */}
      <Table striped>
        <thead>
          <tr>
            <th>
              {t(
                'pageScreenAndProtect.detailsPage.propertiesSelectModal.tableTitle',
              )}
            </th>
          </tr>
        </thead>
        <tbody>
          {properties.map((property) => (
            <tr key={property.uid}>
              <td>{formatPropertyName(property)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PropertiesTableContainer>
  );
};

export default PropertiesTable;
